module.exports = __webpack_public_path__ + "img/ico-2.c0ce11d0.svg";